import * as Yup from 'yup';

export const schema = Yup.object({
	phone: Yup.string().nullable(true),
	fax_number: Yup.string().nullable(true),
	email: Yup.string().email().required(),
	aux_email_1: Yup.string().email().nullable(true),
	aux_email_2: Yup.string().email().nullable(true),
	webpage: Yup.string().url().nullable(true),
});
